import React from 'react';
import Grid from '@material-ui/core/Grid';
import DashboardLayout from './_components/DashboardLayout';

const message = 'Welcome to EnergyDB';

export const Home: React.FC = () => (
  <DashboardLayout>
    <h1>{message}</h1>
    <img src="/logo192.png"></img>
  </DashboardLayout>
)

export default Home;
